import type { ToastProps } from 'react-aria-components';
import { UNSTABLE_Toast, UNSTABLE_ToastContent } from 'react-aria-components';

import { CheckCircle, Info, TriangleAlert, X } from '@repo/media/lucide';

import { Button } from '../button/button.tsx';
import { composeTailwindRenderProps } from '../utils.ts';
import type { ToastContent } from './utils.ts';
import { toastStyles } from './utils.ts';

export function Toast({
  toast,
  className,
  ...props
}: ToastProps<ToastContent>) {
  const variant = toast.content.variant || 'neutral';
  const action = toast.content.action;
  const Icon = variant === 'info'
    ? Info
    : variant === 'positive'
      ? CheckCircle
      : variant === 'warning' || variant === 'negative'
        ? TriangleAlert
        : undefined;

  return (
    <UNSTABLE_Toast
      {...props}
      toast={toast}
      className={composeTailwindRenderProps(className, toastStyles({ variant }))}
    >
      <div className="flex gap-4 items-start">
        {Icon && <Icon size={20} className="stroke-[var(--color)]" />}
        <UNSTABLE_ToastContent>
          {toast.content.title && <p slot="title" className="font-medium">{toast.content.title}</p>}
          {toast.content.description && <p slot="description">{toast.content.description}</p>}
        </UNSTABLE_ToastContent>
      </div>
      <div className="flex gap-1 items-center shrink-0">
        {action && (
          <Button
            variant="soft"
            color="primary"
            size="sm"
            action={() => action.onPress()}
          >
            {action.label}
          </Button>
        )}
        <Button
          slot="close"
          variant="ghost"
          color="secondary"
          size="icon-sm"
          className="-mr-1 -mt-1"
          icon={{ component: <X /> }}
        />
      </div>
    </UNSTABLE_Toast>
  );
}
